import React, { useState, useEffect, useRef } from "react";
import { FaStar } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { fetchInitialReviews, fetchMoreReviews, resetReviews } from "../../../Features/Reviews/reviewsSlice";
import CircularProgress from "@mui/material/CircularProgress";
import "./AdditionalInfo.css";
const AdditionalInfo = ({ product }) => {
  const [activeTab, setActiveTab] = useState("aiTab2");
  const dispatch = useDispatch();
  const { reviews, lastDoc, loading } = useSelector((state) => state.reviews);

  useEffect(() => {
    if (product?.productId) {
      dispatch(resetReviews()); // Reset reviews when product changes
      dispatch(fetchInitialReviews(product.productId)); // Fetch first batch
    }
  }, [product, dispatch]);

  const handleLoadMore = () => {
    if (lastDoc) {
      dispatch(fetchMoreReviews({ productId: product.productId, lastDoc })); // Fetch next batch
    }
  };
  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  const colors = [
    "#F44336", "#E91E63", "#9C27B0", "#673AB7",
    "#3F51B5", "#2196F3", "#03A9F4", "#00BCD4",
    "#009688", "#4CAF50", "#8BC34A", "#CDDC39",
    "#FFC107", "#FF9800", "#FF5722", "#795548"
  ];

  const getAvatarColor = (name) => {
    if (!name) return "#000"; // Default color if name is not available
    const charCode = name.charCodeAt(0);
    return colors[charCode % colors.length]; // Assign color based on first character
  };

  return (
    <>
      <div className="productAdditionalInfo">
        <div className="productAdditonalInfoContainer">
          <div className="productAdditionalInfoTabs">
            <div className="aiTabs">
              <p
                onClick={() => handleTabClick("aiTab2")}
                className={activeTab === "aiTab2" ? "aiActive" : ""}
              >
                Additional Information
              </p>
            </div>
          </div>
          <div className="productAdditionalInfoContent">

            {activeTab === "aiTab2" && (
              <div className="aiTabReview">
                <div className="aiTabAdditionalInfo">
                  <div className="descriptionPara">
                    <h3>Why choose product?</h3>
                    <p>
                      {product.whyChooseUs}
                      {/* <ul>
                   <li>Creat by cotton fibric with soft and smooth</li>
                   <li>
                     Simple, Configurable (e.g. size, color, etc.), bundled
                   </li>
                   <li>Downloadable/Digital Products, Virtual Products</li>
                 </ul> */}
                    </p>
                  </div>
                  <div className="additionalInfoContainer">
                    <h6>Weight</h6>
                    <p> {product.weight} kg</p>
                  </div>
                  <div className="additionalInfoContainer">
                    <h6>Dimensions</h6>
                    <p> {product.dimensions} cm</p>
                  </div>
                </div>
                <div className="aiTabReviewContainer">
                  <h3>Reviews</h3>
                  {/* <div className="userReviews">
                    <div
                      className="userReview"
                      style={{ borderBottom: "1px solid #e4e4e4" }}
                    >
                      <div className="userReviewImg">
                        <img src={user1} alt="" />
                      </div>
                      <div className="userReviewContent">
                        <div className="userReviewTopContent">
                          <div className="userNameRating">
                            <h6>Janice Miller</h6>
                            <div className="userRating">
                              <FaStar color="#FEC78A" size={10} />
                              <FaStar color="#FEC78A" size={10} />
                              <FaStar color="#FEC78A" size={10} />
                              <FaStar color="#FEC78A" size={10} />
                              <FaStar color="#FEC78A" size={10} />
                            </div>
                          </div>
                          <div className="userDate">
                            <p>April 06, 2023</p>
                          </div>
                        </div>
                        <div
                          className="userReviewBottomContent"
                          style={{ marginBottom: "30px" }}
                        >
                          <p>
                            Nam libero tempore, cum soluta nobis est eligendi
                            optio cumque nihil impedit quo minus id quod maxime
                            placeat facere possimus, omnis voluptas assumenda
                            est…
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="userReview">
                      <div className="userReviewImg">
                        <img src={user2} alt="" />
                      </div>
                      <div className="userReviewContent">
                        <div className="userReviewTopContent">
                          <div className="userNameRating">
                            <h6>Benjam Porter</h6>
                            <div className="userRating">
                              <FaStar color="#FEC78A" size={10} />
                              <FaStar color="#FEC78A" size={10} />
                              <FaStar color="#FEC78A" size={10} />
                              <FaStar color="#FEC78A" size={10} />
                              <FaStar color="#FEC78A" size={10} />
                            </div>
                          </div>
                          <div className="userDate">
                            <p>April 12, 2023</p>
                          </div>
                        </div>
                        <div className="userReviewBottomContent">
                          <p>
                            Nam libero tempore, cum soluta nobis est eligendi
                            optio cumque nihil impedit quo minus id quod maxime
                            placeat facere possimus, omnis voluptas assumenda
                            est…
                          </p>
                        </div>
                      </div>
                    </div>
                  </div> */}
                  <div className="userReviews">
                    {loading && reviews.length === 0 ? (
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'center',
                        }}
                      > <CircularProgress size={30} /></div>

                    ) : reviews.length > 0 ? (
                      reviews.map((review, index) => (
                        <div key={review.id} className="userReview" style={{ borderBottom: "1px solid #e4e4e4" }}>
                          {/* <div className="userReviewImg">
                            <img src={review.photo || "/default-avatar.png"} alt="" />
                          </div> */}
                          <div className="userReviewImg">
                            {review.photo ? (
                              <img src={review.photo} alt="User Review" />
                            ) : (
                              <div className="avatarPlaceholder"
                                style={{ backgroundColor: getAvatarColor(review.user) }}
                              >
                                <span className="avatarText">
                                  {review.user?.charAt(0).toUpperCase()}
                                </span>

                              </div>
                            )}
                          </div>
                          <div className="userReviewContent">
                            <div className="userReviewTopContent">
                              <div className="userNameRating">
                                <h6>{review.user || "Anonymous"}</h6>
                                <div className="userRating">
                                  {[...Array(review.rating)].map((_, i) => (
                                    <FaStar key={i} color="#FEC78A" size={10} />
                                  ))}
                                </div>
                              </div>
                              <div className="userDate">
                                <p>{new Date(review.createdAt.seconds * 1000).toLocaleDateString()}</p>
                              </div>
                              {review.images?.length > 0 && (
                                <div className="reviewImagesContainer">
                                  {review.images.map((image, index) => (
                                    <img key={index} src={image} alt={`review-img-${index}`} className="reviewImage" />
                                  ))}
                                </div>
                              )}
                            </div>
                            <div className="userReviewBottomContent" style={{ marginBottom: "30px" }}>
                              <p>{review.text}</p>
                            </div>
                          </div>
                        </div>
                      ))
                    ) : (
                      <p>No reviews yet.</p>
                    )}
                  </div>
                  {lastDoc && (
                    <button onClick={handleLoadMore} disabled={loading} className="seeMoreButton">
                      {loading ? <div className="loadingIndicator">
                        <CircularProgress size={30} />
                      </div> : "See More"}
                    </button>
                  )}
                </div>
              </div>
            )}

            {/* Tab3 */}

            {activeTab === "aiTab3" && (
              <div className="aiTabAdditionalInfo">
                <div className="descriptionPara">
                  <h3>Why choose product?</h3>
                  <p>
                    {product.whyChooseUs}
                    {/* <ul>
                   <li>Creat by cotton fibric with soft and smooth</li>
                   <li>
                     Simple, Configurable (e.g. size, color, etc.), bundled
                   </li>
                   <li>Downloadable/Digital Products, Virtual Products</li>
                 </ul> */}
                  </p>
                </div>
                <div className="additionalInfoContainer">
                  <h6>Weight</h6>
                  <p> {product.weight} kg</p>
                </div>
                <div className="additionalInfoContainer">
                  <h6>Dimensions</h6>
                  <p> {product.dimensions} cm</p>
                </div>
                {/* <div className="additionalInfoContainer">
             <h6>Size</h6>
             <p> XS, S, M, L, XL</p>
           </div> */}
                {/* <div className="additionalInfoContainer">
             <h6>Color</h6>
             <p> Black, Orange, White</p>
           </div>
           <div className="additionalInfoContainer">
             <h6>Storage</h6>
             <p> Relaxed fit shirt-style dress with a rugged</p>
           </div> */}
              </div>
            )}
          </div>
        </div>
      </div>

    </>
  );
};

export default AdditionalInfo;
